import type { PropertyFilters } from '~/core/entities/property/filters';

export const INITIAL_FILTERS: PropertyFilters = {
	transactionType: 'sell',
	propertyTypes: [],
	locationSlug: 'sao-paulo-sp-brasil'
};

Object.freeze(INITIAL_FILTERS);

export function usePropertiesListingFilters() {
	const filters = ref<PropertyFilters>({ ...INITIAL_FILTERS });

	return { filters };
}
